import { render, staticRenderFns } from "./RealEstateRentContractEdit.vue?vue&type=template&id=70e421ea&"
import script from "./RealEstateRentContractEdit.vue?vue&type=script&lang=js&"
export * from "./RealEstateRentContractEdit.vue?vue&type=script&lang=js&"
import style0 from "./RealEstateRentContractEdit.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports